import { cn } from '~/shadcn/lib/utils'

function PageContainer({
  children,
  className,
}: {
  children?: React.ReactNode
  className?: string
}) {
  return <div className={cn('px-5 md:px-10', className)}>{children}</div>
}

export { PageContainer }
